import { render, staticRenderFns } from "./SnowCheckboxGroup.vue?vue&type=template&id=2806e111&"
import script from "./SnowCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./SnowCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports